<div class="subscriptionView verticalCenterView">
  <div class="subscriptionView__loader" >
      <mat-spinner *ngIf="!canShow"></mat-spinner>
  </div>
  
  <div class="subscriptionView__wrap" *ngIf="canShow">
    <div class="subscriptionView__info">
      <h2 *ngIf="!isSubscriptionInfo">Subscribe to our service!</h2>
      <h2 *ngIf="isSubscriptionInfo">
        You currently do not have an active subscription!<br /><span style="font-size: 16px; color:#f92c7a">Fill data on form and subscribe now! You get:</span>
      </h2>
      <div class="infoList subscriptionView__infoList">
        <div class="infoList__item">
          <div class="iconWrap"><i class="far fa-images icon"></i></div>
          <span>Unlimited pictures for Posts and Messages</span>
        </div>
        <div class="infoList__item">
          <div class="iconWrap"><i class="fas fa-eye-slash icon"></i></div>
          <span>Ad free surfing</span>
        </div>
        <div class="infoList__item">
          <div class="iconWrap"><i class="fas fa-ad icon"></i></div>
          <span>No third party advertisement in your ads</span>
        </div>
        <div class="infoList__item">
          <div class="iconWrap"><i class="fas fa-bullhorn icon"></i></div>
          <span>Your ads appear on top</span>
        </div>
        <div class="infoList__item">
          <div class="iconWrap"><i class="far fa-id-badge icon"></i></div>
          <span>Verified badge on your user</span>
        </div>
        <div class="infoList__item">
          <div class="iconWrap"><i class="fas fa-laugh-wink icon"></i></div>
          <span>Use emojis in ad and messages</span>
        </div>
        <div class="infoList__item">
          <div class="iconWrap"><i class="fas fa-certificate icon"></i></div>
          <span>Premium label</span>
        </div>
      </div>
    </div>
    <div>
      <div class="subscriptionView__autorizeInfo">
        <div class="">
          <b>100% Secure Payment!</b>
        </div>
        <div class="secure-image">
          <b>Secured By:</b>
          <img src="/images/authorizenet.png">
        </div>
      </div>
      <div class="row">
        <b>Charge will appear on your credit card statement as "Armax Technology"</b>
      </div>
    </div>
    <form class="formFields subscriptionView__formFields" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="formFields__fieldsWrap">
        <mat-form-field class="formFields__subscriptionPeriod">
          <mat-select placeholder="Period"
                      formControlName="subscriptionPeriod"
                      (selectionChange)="show($event)">
            <mat-option value="1">
              1 year subscription $4.60/mo - <b>$55.20</b>
            </mat-option>
            <mat-option value="2"> Monthly - <b>$6.99</b> cancel anytime</mat-option>
            <mat-option value="3"> <b>$1.99</b> per single premium ad - no monthly subscription</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="formFields__priceInfo" *ngIf="showSave == '1'">
          <span>$55.20 / year </span>
          <span class="showsave">save $28.68</span>
        </div>

        <div class="formFields__priceInfo" *ngIf="showSave == '2'">
          $83,88 / year
        </div>

        <mat-form-field class="formFields__firstName">
          <input formControlName="firstName"
                matInput
                placeholder="First name *"
                type="text" />
          <mat-error *ngIf="form.controls['firstName'].hasError('required')">
            Required field
          </mat-error>
        </mat-form-field>
    
        <mat-form-field class="formFields__lastName">
          <input formControlName="lastName"
                matInput
                placeholder="Last name *"
                type="text" />
          <mat-error *ngIf="form.controls['lastName'].hasError('required')">
            Required field
          </mat-error>
        </mat-form-field>
    
        <mat-form-field class="formFields__zip">
          <input formControlName="zip"
                matInput
                placeholder="Zip Code *"
                type="text" />
          <mat-error *ngIf="form.controls['zip'].hasError('required')">
            Required field
          </mat-error>
        </mat-form-field>

        <mat-form-field class="formFields__creditCard">
          <input formControlName="creditCard"
                matInput
                placeholder="Credit Card *"
                id="cc-number"
                type="tel"
                autocomplete="cc-number"
                ccNumber />
          <mat-error *ngIf="form.controls['creditCard'].hasError('ccNumber')">
            Please enter a valid credit card number.
          </mat-error>
        </mat-form-field>
      
        <div class="formFields__label">Expiration Date:</div>
        <div class="formFields__expirationRow">
          <mat-form-field class="formFields__expirationDateMonth">
            <input formControlName="expirationDateMonth"
                  matInput
                  placeholder="MM*"
                  id="cc-exp-date-m"
                  type="tel" />
            <mat-error *ngIf="
              form.controls['expirationDateMonth'].hasError('required')
            ">
              Please enter a valid expiration date - MM
            </mat-error>
          </mat-form-field>

          <div class="formFields__expirationRowSeparator">
            /
          </div>

          <mat-form-field class="formFields__expirationDateYear">
            <input formControlName="expirationDateYear"
                  matInput
                  placeholder="YYYY*"
                  id="cc-exp-date-y"
                  type="tel" />
            <mat-error *ngIf="
              form.controls['expirationDateYear'].hasError('required')
            ">
              Please enter a valid expiration date - YYYY
            </mat-error>
          </mat-form-field>
        </div>
        <mat-form-field class="formFields__cvc">
          <input formControlName="cvc"
                matInput
                placeholder="CVC *"
                id="cc-cvc"
                type="tel"
                autocomplete="off"
                ccCVC />
          <mat-error *ngIf="form.controls['cvc'].hasError('required')">
            Please enter a CVC number
          </mat-error>
        </mat-form-field>
      </div>
  
      <button class="formFields__submit"
              type="submit"
              mat-raised-button 
              color="primary">
        <span *ngIf="!creating">
          {{ submitButtonText }}
        </span>
        <mat-spinner *ngIf="creating" diameter="30"></mat-spinner>
      </button>
    </form>

    <ng-template #errorDialog>
      <h2 matDialogTitle>Create subscription error</h2>
      <p matDialogContent><em>{{errorMessage}}</em></p>
      <mat-dialog-actions>
        <button mat-button matDialogClose>Ok</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</div>
